// import React from "react";
// /** Components Import */
// import { Backdrop as MuiBackdrop, CircularProgress, Fade } from "@mui/material";

// function LoadingBasic({
// 	open = false, // bool
// 	children = <CircularProgress color="inherit" />, // node
// 	classes, // object
// 	component, // elementType
// 	components, // { Root?: elementType }
// 	componentsProps, // { root?: object }
// 	invisible = false, // bool
// 	slotProps, // { root?: object }
// 	slots, // { root?: elementType }
// 	sx, // object
// 	TransitionComponent = Fade, // elementType
// 	transitionDuration, // number | { appear?: number, enter?: number, exit?: number }
// 	onClick = () => {},
// }) {
// 	const ClickBackdrop = () => {
// 		onClick();
// 	};

// 	return (
// 		<MuiBackdrop
// 			open={open}
// 			classes={classes}
// 			component={component}
// 			components={components}
// 			componentsProps={componentsProps}
// 			invisible={invisible}
// 			slotProps={slotProps}
// 			slots={slots}
// 			sx={sx}
// 			TransitionComponent={TransitionComponent}
// 			transitionDuration={transitionDuration}
// 			onClick={ClickBackdrop}
// 		>
// 			{children}
// 		</MuiBackdrop>
// 	);
// }

// export default React.memo(LoadingBasic);

import React from 'react';
import { CircularProgress, Typography, Box, Paper } from '@mui/material';
import { useSelector } from 'react-redux';

function LoadingPopup({ open = false, message = '로딩 중입니다...', sx = {} }) {
  const openReducer = useSelector((state) => state.loading.open);

  if (!openReducer) {
    if (!open) return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
        backdropFilter: 'blur(3px)',
        backgroundColor: 'rgba(0, 0, 0, 0.2)', // 배경 어둡게
        ...sx,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          padding: 4,
          borderRadius: 4,
          background: 'linear-gradient(135deg, #f0f4ff, #ffffff)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minWidth: 250,
          animation: 'fadeIn 0.3s ease-in-out',
        }}
      >
        <CircularProgress
          sx={{ color: '#1976d2' /* primary blue */ }}
          thickness={5}
          size={50}
        />
        <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 500 }}>
          {message}
        </Typography>
      </Paper>
    </Box>
  );
}

export default React.memo(LoadingPopup);
